export enum ButtonColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WARN = 'warn',
}
